// Заглушка для экранов ТЗ раздел 3.3, ещё не реализованных на Этапе 5 (см. docs/PLAN.md) —
// маршрут уже существует (роутинг ниже покрывает все 8 экранов сразу), сам экран — нет.
import { useTranslation } from "react-i18next";

export function StubScreen({ titleKey }: { titleKey: string }) {
  const { t } = useTranslation();
  return (
    <div>
      <h1>{t(titleKey)}</h1>
      <p>{t("stub_not_ready")}</p>
    </div>
  );
}
